import React from 'react';
import {
  OldCustomFieldOption,
  OldCustomField,
} from '@teetsh/app/src/types/oldCustomField';
import { Items } from 'containers/CahierJournal/DayColumn/Seance/CJEventBody/Items';
import HtmlViewer from '@teetsh/app/src/components/HtmlViewer';
import { CustomFieldTitle } from './CustomFieldTitle';
import { CustomFieldDefinition } from 'types/customField';
import { buildCustomFieldOptions } from 'components/OldCustomFields/utils';

interface Props {
  customField: OldCustomField;
  customFieldDefinition?: CustomFieldDefinition;
  print?: boolean;
  onChange: (v: OldCustomField) => void;
}

export function CustomFieldRO(props: Props) {
  const { customField, customFieldDefinition, print } = props;

  // in print, definitions are not provided...but fields are already hydrated by the API
  // si for now we have to deal with this special case and use either one or the other
  const enrichedCustomField = {
    ...customField,
    singularName: customFieldDefinition?.name || customField.singularName,
    pluralName: customFieldDefinition?.pluralName || customField.pluralName,
    type: customFieldDefinition?.type || customField.type,
  };

  if (
    enrichedCustomField.type !== 'text' &&
    enrichedCustomField.type !== 'multiselect' &&
    enrichedCustomField.type !== 'select' &&
    enrichedCustomField.type !== 'multitag'
  ) {
    // not supported yet
    return null;
  }

  switch (enrichedCustomField.type) {
    case 'text':
      return (
        <div>
          <CustomFieldTitle title={enrichedCustomField.singularName} />
          <HtmlViewer
            text={customField.value as string}
            onChange={v => props.onChange({ ...customField, value: v })}
            print={print}
          />
        </div>
      );

    case 'select':
    case 'multitag':
      return (
        <Items
          key={customField.id}
          title={enrichedCustomField.singularName || ''}
          pluralTitle={enrichedCustomField.pluralName || ''}
          items={
            // en print l'utilisateur n'est pas connecté, on doit donc hydrater les custom fields coté API et les utiliser tel quel coté front
            print
              ? (customField.value as unknown as OldCustomFieldOption[])
              : buildCustomFieldOptions(
                  customField.value as string[],
                  customFieldDefinition,
                )
          }
        />
      );
    case 'multiselect':
      return (
        <Items
          key={customField.id}
          title={enrichedCustomField.singularName || ''}
          pluralTitle={enrichedCustomField.pluralName || ''}
          items={customField.items}
        />
      );
  }
}
